import { create } from 'zustand'

type EkycOpenIntent = 'prompt' | 'prerequisites'

interface EkycPromptStore {
  /**
   * Increments on each open request so the host always re-opens,
   * even if a previous forced-open was already true.
   */
  openRequestId: number
  /** How the host should present the flow for this open request. */
  openIntent: EkycOpenIntent
  /** Unverified pill / Rewards nag — show Verify / Start eKYC prompt first. */
  openFromChip: () => void
  /** Signup-survey "Start eKYC" — jump straight to I understand + session. */
  openPrerequisites: () => void
  /** Clear pending open intents (e.g. on logout). */
  reset: () => void
}

export const useEkycPromptStore = create<EkycPromptStore>((set) => ({
  openRequestId: 0,
  openIntent: 'prompt',
  openFromChip: () =>
    set((s) => ({ openRequestId: s.openRequestId + 1, openIntent: 'prompt' })),
  openPrerequisites: () =>
    set((s) => ({
      openRequestId: s.openRequestId + 1,
      openIntent: 'prerequisites',
    })),
  reset: () => set({ openRequestId: 0, openIntent: 'prompt' }),
}))
